$(document).ready(function(){
	
	$("select#facility").on("change",function(){
		
		if ( $('select#facility option[value="'+$(this).val()+'"]').attr("data-dementia") != undefined ) {
			
			$("#dementia").removeAttr("disabled");
			$("#dementia").next().removeAttr("style");
			
		} else {
			
			$("#dementia").prop("disabled","disabled");
			$("#dementia").next().css("color","#ccc");
			
		}
		
		
		if ( $('select#facility option[value="'+$(this).val()+'"]').attr("data-doublerooms") != undefined ) {
			
			$('#roomtype option[value="2"]').removeAttr("disabled");
			$("select#roomtype")[0].sumo.enableItem(1);
			
		} else {
			
			$('#roomtype option[value="2"]').prop("disabled","disabled");
			$("select#roomtype")[0].sumo.disableItem(1);
			
		}
		// roomtype
		
		
	});
	
});